module.exports = __webpack_public_path__ + "img/hero_ellipse.9e63f79c.png";